import ClassSelect from './ClassSelect';

export default ClassSelect;
